export const TWAP_DEFAULT_MIN = '8000';
export const TWAP_DEFAULT_MAX = '10000';
export const TWAP_DEFAULT_INTERVAL = '3600';

